export default {
  TYPE_OF: 'Organisme de Formation',
  TYPE_ESAT: 'ESAT',
  TYPE_ESSMS: 'ESSMS',
  TYPE_ENTREPRISE: 'Entreprise',
  TYPE_ASSOCIATION: 'Association',
  TYPE_AUTRE: 'Autre',
  TYPE_PUBLIC: 'Établissement public',
  TYPE_PARTICULIER: 'Particulier',
};